import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"pa-0 px-4 pb-4 pb-md-10 px-md-0"},[_c(VRow,_vm._l((_vm.sortedArticles),function(article,index){return _c(VCol,{key:index,staticClass:"pb-0 d-flex mt-1",attrs:{"cols":"12","sm":"6","md":"6","lg":"4"}},[_c('ModalPostDetail',{staticClass:"flex-grow-1",attrs:{"article":article}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }